import Api from '../api';

class ActivityLogService {
  async getAllLogs(
    user_id: string,
    pageNumer: number,
    limit: number,
    options?: { search?: string; startDate?: number; endDate?: number; action?: string; device?: string }
  ) {
    try {
      let url = `/activity-logs?pageNumber=${pageNumer}&limit=${limit}`;
      if (user_id && user_id !== '') {
        url = url + `&user_id=${user_id}`;
      }
      if (options?.search) url += `&search=${encodeURIComponent(options.search)}`;
      if (options?.startDate) url += `&start_date=${options.startDate}`;
      if (options?.endDate) url += `&end_date=${options.endDate}`;
      if (options?.action) url += `&action=${encodeURIComponent(options.action)}`;
      if (options?.device) url += `&device=${encodeURIComponent(options.device)}`;

      let response = await Api.get(url)
      return response.data;
    } catch (err) {
      console.error("Error in getAll Activity Logs:", err);
      return {logs: {}, total: 0};
    }
  };

  async getUserTrends(params: { startDate?: number; endDate?: number; device?: string; action?: string }) {
    const query = new URLSearchParams();
    if (params.startDate) query.append('start_date', String(params.startDate));
    if (params.endDate) query.append('end_date', String(params.endDate));
    if (params.device) query.append('device', params.device);
    if (params.action) query.append('action', params.action);
    const res = await Api.get(`/activity-logs/trends?${query.toString()}`);
    return res.data;
  }

  async getActiveUsersCount(params: { startDate?: number; endDate?: number; device?: string; action?: string }) {
    const query = new URLSearchParams();
    if (params.startDate) query.append('start_date', String(params.startDate));
    if (params.endDate) query.append('end_date', String(params.endDate));
    if (params.device) query.append('device', params.device);
    if (params.action) query.append('action', params.action);
    const res = await Api.get(`/activity-logs/active-users?${query.toString()}`);
    return res.data;
  }

  async getAllUsers(orgid? :any){
    let queryParams=`/get-all-users`;
    if(orgid && orgid !== ''){
        queryParams +=`?orgid=${(orgid)}`
    }
        
    let response = await Api.get(queryParams)
    return response.data
  }

}

export default new ActivityLogService()